import { createSelector } from 'reselect';
import { StoreState } from '../../store';
import { makeSelectSmartsheetUsers } from '../Admin/Selectors';

export const orgViewsSelector = (state: StoreState) => state.ownershipTransfer.get('orgViews').toJS();
export const pendingOwnershipTransfersSelector = (state: StoreState) => state.ownershipTransfer.get('pendingOwnershipTransfers').toJS();
export const pendingTransfersSelector = (state: StoreState) => state.ownershipTransfer.get('pendingOwnershipTransfers').get('data');
export const ownershipTransferErrorSelector = (state: StoreState) => state.ownershipTransfer.get('error');
export const allUsersSelector = createSelector(makeSelectSmartsheetUsers(), (stateSmartsheetUsers) => stateSmartsheetUsers);
